<!-- Risk Check Cards -->
@if (checksLoading()) {
  <div class="d-flex justify-content-center align-items-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
} @else {
  @for (check of displayChecks(); track check.check_id) {
    <div [id]="'risk-check-' + check.check_id">
      <app-risk-check-card
        [riskCheck]="check"
        [isExpanded]="expandedRiskId() === check.check_id"
        [acceptedCount]="getAcceptedCount(check.check_id)"
        (toggle)="onToggleExpand($event)"
      />

      @if (expandedRiskId() === check.check_id) {
        <app-risk-check-detail
          [riskCheck]="check"
          [organizationId]="organizationId()!"
          (entityAction)="onEntityAction($event)"
          (allAccepted)="onAllAccepted($event)"
          (checkReopened)="onCheckReopened($event)"
        />
      }
    </div>
  } @empty {
    <div class="text-center text-muted py-5">
      <p>No risk checks available.</p>
    </div>
  }
}
